import { IModelBase } from 'common-components'
import { HttpClient } from '@angular/common/http'

import { Injectable } from '@angular/core'
import { SmODataConfiguration } from '@exchange/services/core/odata'
import { ODataService } from 'common-services'

export interface IFeeSchedule extends IModelBase {
  Name: string
  ActiveOnDateTime: Date
  ExpiresOnDateTime: Date
  ModifiedByFullName: string
  ModifiedOn: Date
}

@Injectable()
export class FeeScheduleODataService extends ODataService<IFeeSchedule> {
  constructor(protected http: HttpClient, protected config: SmODataConfiguration) {
    super(http, config)
    this.typeName = 'FeeSchedules'
  }
}
